import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import React, { useEffect, useState } from "react";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { useFirebase } from "contexts/FirebaseAuthContext";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { EntityChatRoom } from "types/chat";
import { Spinner } from "reactstrap";
import CollaborationChatMessages, {
    useCollaborationChatMessages,
} from "./CollaborationChatMessages";

const CollaborationChat: React.FC<{ activeRoomId: string }> = ({ activeRoomId }) => {
    const entityId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const currentEntityId = entityId;
    const { firebaseUser, db } = useFirebase();
    const [entityChatRoom, setEntityChatRoom] = useState<EntityChatRoom | null>(null);
    const [loading, setLoading] = useState(true);

    const messagesState = useCollaborationChatMessages({ entityChatRoom, currentEntityId });

    useEffect(() => {
        if (!firebaseUser || !db || !activeRoomId || !currentEntityId) return;

        setLoading(true);
        const roomRef = doc(db, "entityChatRooms", currentEntityId, "rooms", activeRoomId);

        const unsubscribe = onSnapshot(
            roomRef,
            (roomDoc) => {
                if (roomDoc.exists()) {
                    setEntityChatRoom({ ...roomDoc.data(), uuid: activeRoomId } as EntityChatRoom);
                } else {
                    setEntityChatRoom(null);
                }
                setLoading(false);
            },
            (error) => {
                console.error("Failed to subscribe to entity chat room:", error);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [firebaseUser, db, activeRoomId, currentEntityId]);

    return (
        <div className="position-relative h-100">
            <div className="chat-container h-100">
                {entityChatRoom ? (
                    <CollaborationChatMessages
                        entityChatRoom={entityChatRoom}
                        messagesState={messagesState}
                        loading={loading}
                        showEmptyState
                        dayLabelVariant="inline"
                        messageInputClassName="py-3"
                    />
                ) : loading ? (
                    <div className="d-flex flex-column gap-2 h-100 w-100 justify-content-center align-items-center">
                        <Spinner />
                        <div>Loading Chat...</div>
                    </div>
                ) : (
                    <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                        <div className="length-zero m-0">
                            <h3>No Chat Selected!</h3>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CollaborationChat;
